import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  Button,
} from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import { useAuth } from "@/components/shared/auth-provider";
import { useAuthState } from "@/store/auth";
import { useRoute } from "@/components/shared/router";

export const OverdueInvoiceModal = () => {
  const { replace } = useRoute();
  const { isAuthenticated } = useAuth();
  const invoicesHitsMaxOverdueDays = useAuthState(
    (state) => state.data.userInfo.billingAccount.invoicesHitsMaxOverdueDays,
  );

  if (!isAuthenticated || !invoicesHitsMaxOverdueDays) return null;

  const onViewInvoice = () => {
    replace({
      pageKey: "invoices",
    });
  };

  return (
    <Dialog open>
      <DialogContent className="sm:w-[343px] md:w-[400px]">
        <DialogHeader>
          <DialogTitle>Payment Required Before Booking</DialogTitle>
        </DialogHeader>
        <Typography variant="body-sm">
          Oops! We can't process your booking because you have an overdue
          invoice. Please complete the payment first.
        </Typography>
        <DialogFooter>
          <Button
            className="w-full"
            variant="primary"
            color="CTA"
            onClick={onViewInvoice}
          >
            View Invoice
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
